import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../components/CTAButton';
import { SearchIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-12 pb-8 md:pt-16 md:pb-12 px-6 overflow-hidden bg-[#FFF0F5]" data-id="element-148">
      <div className="max-w-6xl mx-auto" data-id="element-149">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-150">
          <motion.div className="flex-1 text-center md:text-left" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-151">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6 bg-gradient-to-r from-[#8B2252] via-[#C41E3A] to-[#8B2252] bg-clip-text text-transparent drop-shadow-lg" data-id="element-152">
              DESCONEXIÓN EMOCIONAL
            </h1>
            <h2 className="text-xl md:text-2xl text-terracotta font-medium italic mb-6" data-id="element-153">
              Por qué el amor se apaga aunque todo parezca bien
            </h2>

            <div className="space-y-4 text-lg md:text-xl text-mutedBrown leading-relaxed mb-8" data-id="element-154">
              <p data-id="element-155">
                La guía íntima y práctica para mujeres que se sienten solas
                dentro de su relación y necesitan entender qué se apagó,
                recuperar la conexión emocional o ganar la claridad necesaria
                para decidir sin culpa, sin impulsividad y sin seguir
                desapareciendo dentro de su propio hogar.
              </p>
              <p className="font-medium text-warmBrown" data-id="element-156">
                No quieres destruir tu familia. Pero tampoco quieres seguir
                viviendo sintiéndote sola, invisible y distante dentro de tu
                propia relación.
              </p>
            </div>

            <CTAButton text="QUIERO ENTENDER QUÉ ESTÁ PASANDO" microcopy="Acceso inmediato · Lectura privada · Hecha para mujeres que necesitan claridad emocional real" className="md:items-start" icon={<SearchIcon className="w-5 h-5" data-id="element-158" />} data-id="element-157" />
          </motion.div>

          <motion.div className="flex-1 w-full max-w-md mx-auto md:max-w-none" initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-159">
            <div className="relative" data-id="element-160">
              <div className="absolute inset-0 bg-softGold/20 blur-3xl rounded-full transform scale-90 translate-y-10" data-id="element-161"></div>
              <div className="absolute -top-4 -right-4 bg-[#C41E3A] text-white text-sm font-bold px-4 py-2 rounded-full shadow-lg rotate-3 z-20" data-id="element-162">
                Oferta por Lanzamiento
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/wTK44LUP9MpFhkSSfKiSFh/Cover_de_Ebook_Landing.png" alt="Portada del libro Desconexión Emocional" className="relative z-10 w-full h-auto drop-shadow-2xl rounded-2xl overflow-hidden" data-id="element-163" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}